import viewingData from './gazetteer/viewing-locations.json' with { type: 'json' };

/**
 * Shore-based whale watching locations published by Orca Network, via the
 * MIT-licensed salishsea.io project. These are reference geography, not
 * observations — the map draws them recessively so they never compete with
 * sighting marks.
 */
export interface ViewingLocation {
  id: string;
  name: string;
  region?: string;
  lat: number;
  lon: number;
  /** Requires a hike to reach. */
  hike?: boolean;
  /** Co-located with a public hydrophone. */
  hydrophone?: boolean;
  /** 'orcanetwork' for the built-in list, 'community' for user submissions. */
  source?: 'orcanetwork' | 'community';
  /** Only community points carry a review state; built-ins are always approved. */
  status?: 'approved' | 'pending';
  note?: string;
  submittedBy?: string;
}

export const VIEWING_LOCATIONS: ViewingLocation[] = viewingData as ViewingLocation[];

/**
 * Google Maps links for a spot. `destination` opens turn-by-turn directions
 * (and hands off to the Maps app on a phone); the search link just drops a pin.
 * Coordinates are used rather than the name, because a name like "West Beach
 * Vista" can resolve to the wrong place while a lat/lon cannot.
 */
export function googleMapsDirectionsUrl(lat: number, lon: number): string {
  return `https://www.google.com/maps/dir/?api=1&destination=${lat.toFixed(6)},${lon.toFixed(6)}`;
}

export function googleMapsPinUrl(lat: number, lon: number): string {
  return `https://www.google.com/maps/search/?api=1&query=${lat.toFixed(6)},${lon.toFixed(6)}`;
}
